import { navigateTo, useNuxtApp } from "nuxt/app";
import { ElMessageBox } from "element-plus";
import { useThrottleFn } from "@vueuse/core";
import { useAccountStore } from "~/store/account";

// 登录提示弹窗
const userLoginThrottleFn = () => {
  const { $i18n } = useNuxtApp();
  if (!$i18n) return;
  const { t } = $i18n;
  if (!t) return;
  const tipContent = `
    <h2>${t("account.signUp")}</h2>
    <h2>${t("account.to_explore_the_world_of_3d")}</h2>
    <p class="p-tips">${t("account.loginTips")}</p>
  `;
  return ElMessageBox.confirm(tipContent, t("common.tips"), {
    confirmButtonText: t("account.signUp"),
    cancelButtonText: t("account.logIn"),
    customClass: "custom-confirm login-confirm",
    autofocus: false,
    closeOnPressEscape: false,
    closeOnClickModal: false,
    dangerouslyUseHTMLString: true,
    distinguishCancelAndClose: true,
  });
};

export const userLogin = useThrottleFn(userLoginThrottleFn, 2000, false, true);

export const checkLogin = (userId: string) => {
  return checkLoginCommon(`${userId}/home`);
};

export const checkLoginSplicingRouPath = () => {
  const route = useRoute();
  const path = route.path.replace(/^\//, "");
  console.log("fromPath", path);
  return checkLoginCommon(path);
};

export const checkLoginCommon = (
  fromPath?: string,
  closeCallBack?: () => void
) => {
  const accountStore = useAccountStore();
  const isLogin = !!accountStore && !!accountStore.access_token;
  if (!isLogin) {
    userLogin()
      .then(() => {
        navigateTo("/account/register");
      })
      .catch((err) => {
        if (err === "cancel") {
          navigateTo(
            fromPath ? `/account/login?to=/${fromPath}` : "/account/login"
          );
          return;
        }
        if (closeCallBack) closeCallBack();
      });
    return false;
  }
  return true;
};
